export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'ต้องจ่าย',
}
